<h1 mat-dialog-title>{{ 'support.title' | translate }}</h1>
<div mat-dialog-content>
  <div class="contact-item">
    <mat-icon>play_circle</mat-icon>
    <div>
      <label>{{ 'support.tutorials' | translate }}</label>
      <span (click)="goToTutorials()">{{ 'support.tutorials_description' | translate }}</span>
    </div>
  </div>
  <div class="contact-item">
    <mat-icon>help_outline</mat-icon>
    <div>
      <label>{{ 'support.faq' | translate }}</label>
      <span (click)="goToFaq()"><mat-icon class="external-link-icon">open_in_new</mat-icon>{{ 'support.faq_description' | translate }}</span>
    </div>
  </div>
  <div class="contact-item">
    <mat-icon>email</mat-icon>
    <div>
      <label>{{ 'support.email_label' | translate }}</label>
      <a href="mailto:support@dicom-connect.com">support&#64;dicom-connect.com</a>
    </div>
  </div>
  <div class="contact-item">
    <mat-icon>phone</mat-icon>
    <div>
      <label>{{ 'support.phone_label' | translate }}</label>
      <a href="tel:0970705032">09 70 70 50 32</a>
    </div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>{{ 'support.close' | translate }}</button>
</div>
